import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wp1200 withPadding newsWrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_arrow-L" }, null, -1)
const _hoisted_4 = { class: "mainTitle" }
const _hoisted_5 = { class: "infoNews flex" }
const _hoisted_6 = { class: "dateAndTime" }
const _hoisted_7 = { class: "author" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_author" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", { class: "green" }, null, -1)
const _hoisted_10 = { class: "shortDescription" }
const _hoisted_11 = { class: "boxInfo" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.article)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: { name: 'news' },
            class: "responsiveBack"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.article.title), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.article.datetime !== null
            ? _ctx.$moment(_ctx.article.datetime).format("DD.MM.yyyy hh:mm")
            : _ctx.$moment(_ctx.article.created_at).format("DD.MM.yyyy hh:mm")), 1),
            _createElementVNode("span", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("span", null, _toDisplayString(_ctx.article.author), 1)
            ])
          ]),
          _hoisted_9,
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.article.summary), 1),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.article.image_url)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.article.image_url,
                  alt: _ctx.article.title
                }, null, 8, _hoisted_12))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("p", {
            innerHTML: _ctx.article.body
          }, null, 8, _hoisted_13)
        ]))
      : _createCommentVNode("", true)
  ]))
}